import type { TFunction } from 'i18next';

/**
 * The registries are filled at import time, before any translator exists,
 * so their English stays the fallback and the shown text comes from
 * `pleri/library` where the entry renders. A key per entry keeps the
 * registry the source of what exists and the namespace the source of what
 * it says.
 */
export const registryDescription = (
  t: TFunction<'pleri/library'>,
  kind: 'skill' | 'workspace',
  id: string,
  fallback: string,
): string => t(`${kind}Description_${id}`, { defaultValue: fallback });

/** A tool category is a filter id; this is the word shown for it. */
export const categoryLabel = (
  t: TFunction<'pleri/library'>,
  category: string,
): string => t(`category_${category}`, { defaultValue: category });
